<template>
  <el-container>
    <!-- 主体内容 -->
    <el-header
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>上报舆情详情</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <el-button type="info" icon="el-icon-eleme" @click.native="browser()"
          >舆情来源</el-button
        >
        <el-button type="info" icon="el-icon-back" @click.native="formReturn()"
          >返 回</el-button
        ></el-button-group
      >
    </el-header>
    <el-main>
      <el-tabs type="card" :tab-position="tabPosition">
        <el-tab-pane>
          <span slot="label"><i class="el-icon-date"></i> 舆情信息</span>
          <el-form :model="data.pst" status-icon label-width="100px">
            <el-form-item label="录入人" prop="userName">
              <el-input v-model="data.pst.userName" disabled />
            </el-form-item>
            <el-form-item label="舆情类别" prop="pstType">
              <el-input v-model="data.pstTypeName" disabled />
            </el-form-item>
            <el-form-item label="发贴标题" prop="title">
              <el-input v-model="data.pst.title" disabled />
            </el-form-item>
            <el-form-item label="发贴人" prop="name">
              <el-input v-model="data.pst.name" disabled />
            </el-form-item>
            <el-form-item label="发贴时间" prop="postingTime">
              <el-input v-model="data.pst.postingTime" disabled />
            </el-form-item>
            <el-form-item label="来源" prop="pstSource">
              <el-input v-model="data.pst.pstSource" disabled />
            </el-form-item>
            <el-form-item label="贴子内容" prop="pstContent">
              <el-input
                type="textarea"
                :rows="5"
                v-model="data.pst.pstContent"
                disabled
              />
            </el-form-item>
            <el-form-item label="状态" prop="statusName">
              <el-input v-model="data.statusName" disabled />
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <el-tab-pane v-for="(node, index) in data.nodes" :key="index">
          <span slot="label"
            ><i :class="pstApi.getStatusIcon(node.status)"></i
            >{{ pstApi.getNodeTitle(node.status) }}</span
          >
          <el-form :model="node" status-icon label-width="100px">
            <el-form-item label="转办单位" v-if="node.transferUnitName">
              <el-input v-model="node.transferUnitName" disabled />
            </el-form-item>
            <el-form-item label="办理人">
              <el-input v-model="node.userName" disabled />
            </el-form-item>
            <el-form-item label="提交留言" v-if="node.nodeMessage">
              <el-input
                type="textarea"
                :rows="2"
                v-model="node.nodeMessage"
                disabled
              />
            </el-form-item>
            <el-form-item label="答复内容" v-if="node.nodeContent">
              <el-input
                type="textarea"
                :rows="2"
                v-model="node.nodeContent"
                disabled
              />
            </el-form-item>
            <el-form-item label="状态">
              <el-input :value="node.isSucces ? '已提交' : '未提交'" disabled />
            </el-form-item>
            <el-form-item label="提交时间">
              <el-input
                :value="
                  node.lastTime
                    ? Common.dateFormatter(node.lastTime, 'yyyy-MM-dd hh:mm')
                    : ''
                "
                disabled
              />
            </el-form-item>
            <el-form-item label="佐证材料" v-if="node.uploadCount > 0">
              <el-card class="box-card">
                <!-- 文件上传组件 -->
                <upload :nodeId="node.id" :disabled="true" />
              </el-card>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </el-container>
</template>
  
<script>
import upload from "../../../components/Contents.vue";
export default {
  components: {
    upload,
  },
  created() {
    this.pstApi.setWindowTitle("工单办理详情");
    this.data.pst.id = this.$route.params.id;
    this.getPst(); //读取留言信息
  },
  data() {
    return {
      tabPosition: "right",
      //数据项
      data: {
        statusName: "",
        pstTypeName: "",
        pst: {
          id: "",
        },
        nodes: [],
      },
    };
  },
  methods: {
    //读取舆情信息
    getPst() {
      this.pstApi
        .getHandlePstInfo(this.data.pst.id)
        .then((res) => {
          var data = res.data;
          //console.log(data);
          this.data.pst = data;
          this.data.statusName = data.isSucces == false ? "已保存" : "已提交";
          this.data.pstTypeName = this.pstApi.getPstTypeName(data.pstType);
          this.data.nodes = data.nodeInfos;
          //console.log(this.data.nodes)
        })
        .catch((err) => {
          this.$message.error("读取失败");
        });
    },
    formReturn() {
      this.$router.back();
    },
    browser() {
      window.open(this.data.pst.pstUrl, "_blank");
    },
  },
};
</script>
  
<style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}
//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: auto 5px;
  .btnLeft {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
  .btnTitle {
    flex: 2;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
  .btnStatus {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  .el-button-group > .el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.el-select {
  float: left;
}
.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}
/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}
/deep/.el-textarea.is-disabled .el-textarea__inner {
    background-color: #FFF;
    border-color: #E4E7ED;
    color: #031944;
    cursor:auto;
}
/deep/.el-input.is-disabled .el-input__inner {
    background-color: #FFF;
    border-color: #E4E7ED;
    color: #031944;
    cursor:auto;
}
</style>